import { render, staticRenderFns } from "./ImageInLine.vue?vue&type=template&id=8d15150a&scoped=true&"
import script from "./ImageInLine.vue?vue&type=script&lang=js&"
export * from "./ImageInLine.vue?vue&type=script&lang=js&"
import style0 from "./ImageInLine.vue?vue&type=style&index=0&id=8d15150a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d15150a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VDialog,VIcon,VImg,VRow})
